import {useApi} from "../Api";
import {AncillaryExceptionDetail} from "../types/ancillaryExceptionDetail";
import {AncillaryExceptionEntityResponse} from "../types/ancillaryException";

export const useAncillaryExceptionDetailRepository = () => {
    const {GET, POST, PUT} = useApi();

    const PATH = "/pricing/ancillary-exception-detail";

    function getAncillaryExceptionDetails(ancillaryExceptionId: number): Promise<AncillaryExceptionDetail[]> {
        return GET(`${PATH}/price-matrix?ancillaryExceptionId=${ancillaryExceptionId}`);
    }

    function persistAncillaryExceptionAndDetails({
                                                     prcAncillaryException,
                                                     ancillaryExceptionDetails
                                                 }: {
        prcAncillaryException: AncillaryExceptionEntityResponse,
        ancillaryExceptionDetails: AncillaryExceptionDetail[]
    }): Promise<AncillaryExceptionDetail[]> {
        return PUT(`${PATH}/update-price-matrix`, {prcAncillaryException, ancillaryExceptionDetails});
    }

    function deleteAncillaryExceptionDetails(ancillaryExceptionDetailIds: number[]): Promise<number[]> {
        return POST(`${PATH}/full-delete`, ancillaryExceptionDetailIds);
    }

    return {
        getAncillaryExceptionDetails,
        persistAncillaryExceptionAndDetails
    };
};